import React from 'react';

export default function DotTextSkeleton() {
  return (
    <div className='tw-flex tw-h-full tw-overflow-hidden'>
      <div className='tw-ml-2 tw-flex tw-h-full tw-w-full tw-min-w-[26px] tw-animate-pulse tw-items-center tw-justify-center tw-gap-3'>
        <div className='tw-inline-flex tw-h-2.5 tw-w-2.5 tw-flex-none tw-rounded-full tw-bg-grey-100' />
        <div className='tw-h-3 tw-w-full tw-rounded-lg tw-bg-grey-100' />
      </div>
      <div className='tw-w-full tw-max-w-[44px]' />
    </div>
  );
}
